import React from 'react';
import { Box, Typography } from '@mui/material';
import { EditIcon } from 'components/SVG';
import { SparkButton } from 'sharedComponents/UI';
import { JoinedMemory } from 'types/Memory';
import { useNavigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';

type MemoryPopupFooterProps = {
  joinedMemory: JoinedMemory | undefined;
  closeMemoryCardDialog: () => void;
  isMemoryDialog: boolean;
};

function MemoryPopupFooter({
  joinedMemory,
  closeMemoryCardDialog,
  isMemoryDialog,
}: MemoryPopupFooterProps) {
  const navigate = useNavigate();
  return (
    <Box display='flex' justifyContent='center' gap={2}>
      {joinedMemory?.meta.user.permissions?.canUpdate && (
        <SparkButton
          variant='outlined'
          sx={{
            height: '55px',
            borderRadius: '4px',
            padding: '0px 30px',
          }}
          onClick={() =>
            navigate(`${SPARK_ROUTES.MEMORIES}/${joinedMemory?.id}`)
          }
          startIcon={<EditIcon color='#6267AC' />}
        >
          <Typography
            sx={{
              fontSize: '18px',
              textTransform: 'capitalize',
            }}
          >
            Edit Memory
          </Typography>
        </SparkButton>
      )}
      <SparkButton
        variant='contained'
        sx={{
          height: '55px',
          borderRadius: '4px',
          padding: '0px 30px',
        }}
        onClick={() => {
          if (isMemoryDialog) {
            closeMemoryCardDialog();
            return;
          }
          navigate(`${SPARK_ROUTES.MEMORY}/${joinedMemory?.id}`);
        }}
      >
        <Typography
          sx={{
            fontSize: '18px',
            textTransform: 'capitalize',
          }}
        >
          Ask Question
        </Typography>
      </SparkButton>
    </Box>
  );
}

export default MemoryPopupFooter;
